import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LimitedTermDuration } from '@platform-frontend/checkout-drop-in';
import { Observable } from 'rxjs';

@Pipe({
  name: 'licenseValidityDuration'
})
export class LicenseValidityDurationPipe implements PipeTransform {
  constructor(private readonly translocoService: TranslocoService) {}

  transform(duration: LimitedTermDuration | null): Observable<string> | null {
    if (!duration) {
      return null;
    }
    const translationKey = `marketplace.product.licenseValidity.duration.${duration.unit.toLowerCase()}`;
    return this.translocoService.selectTranslate(translationKey, { count: duration.runtime });
  }
}
